import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.user.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-user-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.user.list/view.scss */
/* src/app/portal.gsdcadmin.user.list/view.scss: no such file or directory */`],
})
export class PortalGsdcadminUserListComponent implements OnInit {
    @Input() view: any;

    constructor(@Inject( Service) public service: Service) { }

    public selectedRole: string = 'all';

    public loading: boolean = false;
    public users: any = [];
    public filteredList: any = [];
    public target_user: any = null;

    public showAdmin: boolean = false;
    public searchTerm: any = "";

    public pagination: any = {
        end: 1,
        start: 1,
        current: 1
    }

    public open: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', "/landing");
        await this.load();
    }

    public async closeModal(tf: boolean) {
        this.open = tf;
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { showAdmin: this.showAdmin, role: this.selectedRole, text: this.searchTerm, page: this.pagination.current });
        if (code != 200) return window.location = "/dashboard";

        this.users = data.rows;
        this.pagination.start = Math.floor((this.pagination.current - 1) / 10) * 10 + 1;;
        this.pagination.end = data.lastpage;

        await this.service.render();
    }

    public async switchUser(user) {
        const { code } = await wiz.call("switch", { user_id: user.id });
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success("switched");
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.selectedRole = role;
        await this.load();
    }

    public userEvent: any = {
        close: async () => {
            this.target_user = null;
            await this.service.render();
        }
    }

    public createUserEvent: any = {
        close: async () => {
            this.create_user = null;
            await this.service.render();
        }
    }

    public async openCreateUserWidget() {
        this.create_user = {}; // 빈 객체로 초기화
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.current = p;
        await this.load();
    }

    public roleLabels: { [key: string]: string } = {
        'admin': '시스템관리자',
        'manager': '서비스담당자',
        'leader': '커뮤니티대표',
        'pi': '그룹대표',
        'user': '개인연구자'
    };
    public getRoleLabel(role: string): string {
        return this.roleLabels[role] || role; // 변환된 값이 없으면 원래 값을 반환
    }
}

export default PortalGsdcadminUserListComponent;